module.exports = __webpack_public_path__ + "img/338-e14ea3.png";